import React from 'react';
import { Link } from 'react-router-dom';
import Breadcrumb from 'react-bootstrap/Breadcrumb';

export const ROLE_ADMIN_PAGE_ROUTE = '/RoleAdmin';

export function RoleAdminPage(): JSX.Element {
  return (
    <>
      <Breadcrumb>
        <Breadcrumb.Item linkAs={Link} linkProps={{ to: '/' }}>
          <small className="font-italic font-weight-bold text-primary">
            Home
          </small>
        </Breadcrumb.Item>
        <Breadcrumb.Item active>
          <small className="font-italic font-weight-bold text-gray">
            User Role Admin
          </small>
        </Breadcrumb.Item>
      </Breadcrumb>
      <div className="container mt-5">
        <div className="row justify-content-center">
          <div className="col-auto">
            <table className="table table-hover">
              <tbody>
                <tr>
                  <td className="align-baseline">
                    <Link
                      to="/Assign"
                      className="btn btn-primary btn-xs btn-block"
                    >
                      <div style={{ width: '160px' }}>Assign Role</div>
                    </Link>
                  </td>
                </tr>
                <tr>
                  <td className="align-baseline">
                    <Link
                      to="/Unassign"
                      className="btn btn-primary btn-xs btn-block"
                    >
                      Unassign Role
                    </Link>
                  </td>
                </tr>
                <tr>
                  <td className="align-baseline">
                    <Link
                      to="/ListUsers"
                      className="btn btn-primary btn-xs btn-block"
                    >
                      User List
                    </Link>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </>
  );
}
